export const iconFontAwesomeHumanitarianPlaneLock = (
	<i className="fa-solid fa-plane-lock"></i>
);
